import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getBalance } from "../../utils/contractHelpers";
import { usdr_token } from "../../utils/Enviroment";
import { userSmartAccount } from "../../components/RecoilAtom";
import { useRecoilValue } from "recoil";
import { convertToMwei, convertFromWei, convertFromWeiEthers } from "../../utils/helpers";
import { USDR_VAULT_SHARE_DECIMALS } from "../../utils/constants";
import { useEoaAccount } from "../useEoaAccount";

export const useCheckAllowance = () => {
  const { account } = useEoaAccount();
  const smartAccount = useRecoilValue(userSmartAccount);
  const web3 = useWeb3();
  let contract;

  const checkAllowance = useCallback(
    async (address) => {
      try {
        contract = await getBalance(usdr_token, web3);
        const allowance = await contract.methods
          .allowance(smartAccount, address)
          .call();
        const formattedAllowance = convertFromWei(
          String(allowance),
          "ether"
        );
        return formattedAllowance;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [smartAccount, contract, web3, account]
  );


  const getAllowanceByAddress =  async (tokenAddress,contractAddress) => {
    try {
      contract = await getBalance(tokenAddress, web3);
      const allowance = await contract.methods
        .allowance(smartAccount, contractAddress)
        .call();
      return allowance;
    } catch (error) {
      console.error("Check Allowance error:", error);
      throw error;
    }
  }



  const TotalLiquidityYouProvide = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web3);
        const userLiquidity = await contract.methods
          .lpBalances(internalAccount)
          .call();
        const formattedAllowance = convertFromWei(
          String(userLiquidity),
          "ether"
        );
        return formattedAllowance;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract, web3]
  );

  const CurrentLiquidityYouProvide = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web3);
        const userLiquidity = await contract.methods
          .balanceOf(usdr_token, internalAccount)
          .call();
        const formattedAllowance = convertFromWeiEthers(
          String(userLiquidity),
          USDR_VAULT_SHARE_DECIMALS
        );
        return formattedAllowance;


      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract, web3]
  );

  const TotalYourReward = useCallback(
    async (helper, address, internalAccount, amount) => {
      try {
        const amountConversion = convertToMwei(amount, USDR_VAULT_SHARE_DECIMALS);
        contract = await helper(address, web3);
        const userReward = await contract.methods
          .convertToAssets(usdr_token, amountConversion)
          .call();
        return userReward;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract]
  );
  const UserReserved = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web3);
        const userReserved = await contract.methods
          .reserved(usdr_token, internalAccount)
          .call();
        const returnUserReserved = userReserved
        return returnUserReserved;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract, web3]
  );
  const UserPrviewUnreserve = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web3);
        const userPrviewUnreserve = await contract.methods
          .previewUnreserve(usdr_token, internalAccount)
          .call();
        const returnUserPrviewUnreserve = userPrviewUnreserve
        return returnUserPrviewUnreserve;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract, web3]
  );
  const TotalShare = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web3);
        const userReward = await contract.methods.totalShares().call();
        return userReward;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract]
  );

  const TotalRewards = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web3);
        const userReward = await contract.methods.totalRewards().call();
        return userReward;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract]
  );

  return {
    TotalRewards,
    checkAllowance,
    TotalLiquidityYouProvide,
    CurrentLiquidityYouProvide,
    TotalYourReward,
    UserReserved,
    TotalShare,
    getAllowanceByAddress,
    UserPrviewUnreserve
  };
};
